<template>
  <div>

        <div v-if="formState === 'signIn'">
            <b-card header="Login" class="text-center" border-variant="light" align="left">

                <b-form>
                <b-form-group
                    id="username"
                    label="Username:"
                    label-for="username"
                    label-cols-lg="3"
                    label-size="sm"
                >
                    <b-form-input
                        id="username"
                        v-model="form.username"
                        type="text"
                        required
                        placeholder="Enter username"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="password"
                    label="Password:"
                    label-for="password"
                    label-cols-lg="3"
                    label-size="sm"
                >
                    <b-form-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        required
                        placeholder="Enter password"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                </b-form-group>

                <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                    <div>{{lastError}}</div>                        
                </b-alert>

                <div align="right">
                        <b-button @click='signIn' variant="info" size="sm" class="mr-2">Sign In</b-button>
                        <b-button @click='passwordReset' variant="info" size="sm" >Password Reset</b-button>
                </div>
                
                </b-form>
            </b-card>
        </div>


        <div v-else-if="formState === 'forgotPassword'">
            <b-card header="Password Reset" class="text-center" border-variant="light"  align="left">
                <b-form>
                <b-form-group
                    id="username"
                    label="Username:"
                    label-for="username"
                    label-cols-lg="3"
                    label-size="sm"
                >
                    <b-form-input
                        id="username"
                        v-model="forgotPassword_form.username"
                        type="text"
                        required
                        placeholder="Enter username"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                </b-form-group>

                <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                    <div>{{lastError}}</div>                        
                </b-alert>

                <div align="right">
                        <b-button @click='forgotPassword' variant="info" size="sm" >Send Code</b-button>
                </div>
                </b-form>

            </b-card>
        </div>

        <div v-else-if="formState === 'resetPassword'">
            <b-card header="Reset Password" class="text-center" border-variant="light"  align="left">

                <b-form>
                    <b-form-group
                        id="username"
                        label="Username:"
                        label-for="username"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                        <b-form-input
                            readonly
                            id="username"
                            v-model="forgotPasswordSubmit_form.username"
                            type="text"
                            required
                            placeholder="Enter username"
                            autocomplete="off"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="code"
                        label="Code:"
                        label-for="code"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                        <b-form-input
                            id="code"
                            v-model="forgotPasswordSubmit_form.code"
                            type="text"
                            required
                            placeholder="Enter code"
                            autocomplete="off"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="password"
                        label="Password:"
                        label-for="password"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                    <b-form-input
                        id="password"
                        v-model="forgotPasswordSubmit_form.password"
                        type="password"
                        required
                        placeholder="Enter new password"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                    </b-form-group>

                    <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                        <div>{{lastError}}</div>                        
                    </b-alert>

                    <div align="right">
                        <b-button @click='forgotPasswordSubmit' variant="info" size="sm">Submit</b-button>
                    </div>
                </b-form>
            </b-card>
        </div>

        <div v-else-if="formState === 'completeNewPassword'">
            <b-card header="New Password" class="text-center" border-variant="light"  align="left">

                <b-form>
                    <b-form-group
                        id="username"
                        label="Username:"
                        label-for="username"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                        <b-form-input
                            readonly
                            id="username"
                            v-model="completeNewPassword_form.username"
                            type="text"
                            required
                            placeholder="Enter username"
                            autocomplete="off"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="password"
                        label="Password:"
                        label-for="password"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                    <b-form-input
                        id="password"
                        v-model="completeNewPassword_form.password"
                        type="password"
                        required
                        placeholder="Enter new password"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                    </b-form-group>

                    <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                        <div>{{lastError}}</div>                        
                    </b-alert>

                    <div align="right">
                        <b-button @click='completeNewPasswordSubmit' variant="info" size="sm">Submit</b-button>
                    </div>
                </b-form>
            </b-card>
        </div>


        <div v-else-if="formState === 'completeMFA'">
            <b-card header="Multi-Factor Auth" class="text-center" border-variant="light"  align="left">
                <b-card-text class="p-2 text-dark bg-info">
                    {{MFAMessage}}
                </b-card-text>
                <b-form>
                    <b-form-group
                        id="username"
                        label="Username:"
                        label-for="username"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                        <b-form-input
                            readonly
                            id="username"
                            v-model="completeMFA_form.username"
                            type="text"
                            required
                            placeholder="Enter username"
                            autocomplete="off"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="code"
                        label="MFA Code:"
                        label-for="code"
                        label-cols-lg="3"
                        label-size="sm"
                    >
                    <b-form-input
                        id="code"
                        v-model="completeMFA_form.code"
                        type="text"
                        required
                        placeholder="Enter MFA code"
                        autocomplete="off"
                        size="sm"
                    ></b-form-input>
                    </b-form-group>

                    <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                        <div>{{lastError}}</div>                        
                    </b-alert>

                    <div align="right">
                        <b-button @click='completeMFASubmit' variant="info" size="sm">Submit</b-button>
                    </div>
                </b-form>
            </b-card>
        </div>


  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
  name: 'home',
  data() {
    return {
        formState:"signIn",  
        form: {
            username: '',
            password: ''
        },
        forgotPassword_form: {
            username: ''
        },
        forgotPasswordSubmit_form: {
            username: '',
            code:'',
            password:''
        },
        completeNewPassword_form: {
            username: '',
            password:'',
            user:null
        },
        completeMFA_form: {
            username: '',
            code:'',
            user:null,
            mfaType:''
        },
        lastError:''
    }
  },
  methods: {
    async signIn() {
        const { username, password } = this.form
        await Auth.signIn(username, password)
        .then( (user) => {
            this.lastError=''
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                this.completeNewPassword_form.username=username
                this.completeNewPassword_form.user=user
                this.formState='completeNewPassword'    
            } else if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                this.completeMFA_form.username=username
                this.completeMFA_form.user=user
                this.completeMFA_form.mfaType=user.challengeName
                this.formState='completeMFA'    ////Auth.confirmSignIn
                if (user.challengeName === 'SMS_MFA'){
                    this.MFAMessage = "Use code sent via " + user.challengeParam.CODE_DELIVERY_DELIVERY_MEDIUM + " to "+ user.challengeParam.CODE_DELIVERY_DESTINATION +"."
                } else {
                    this.MFAMessage = "Use code shown on your MFA device/app."
                }
            }
            //  else if (user.challengeName === 'MFA_SETUP') {
            //     this.completeMFASetup_form.username=username
            //     this.completeMFASetup_form.user=user
            //     this.formState='completeMFASetup'    //Auth.setupTOTP
            // }
            else {
                //AmplifyEventBus.$emit('authState', 'signedIn')
                AmplifyEventBus.$emit('authState', user)
                // this.$store.dispatch('authstore/setUser', user)
                // this.$router.push('/')
            }
        })
        .catch((error) => {
            this.lastError=error.message
            // alert(error.message)
            this.$store.dispatch('authstore/setUser', null)
        })
    },
    async forgotPassword() {
        const { username } = this.forgotPassword_form
        await Auth.forgotPassword(username)
        .then( (data) => {
            this.forgotPasswordSubmit_form.username=username
            this.formState='resetPassword'
            this.lastError=''
        })
        .catch((error) => {
            this.lastError=error.message
            // alert(error.message)
        })
    },
    async forgotPasswordSubmit() {
        const { username, code, password } = this.forgotPasswordSubmit_form
        await Auth.forgotPasswordSubmit(username, code, password)
        .then( (data) => {
            alert('Password successfully reset! Sign in to view the app.')
            this.form.username=username
            this.formState='signIn'    
            this.lastError=''
        })
        .catch((error) => {
            // alert(error.message)
            this.lastError=error.message
        })        
    },
    passwordReset(){
        this.lastError=''
        this.formState='forgotPassword'
    },
    async completeNewPasswordSubmit() {
        const { username, password, user} = this.completeNewPassword_form
        await Auth.completeNewPassword(user, password)
        .then( (user) => {
            this.$store.dispatch('authstore/setUser', user)
            this.lastError=''
            alert('Password successfully reset!')

            if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                this.completeMFA_form.username=username
                this.completeMFA_form.user=user
                this.completeMFA_form.mfaType=user.challengeName
                this.formState='completeMFA'    ////Auth.confirmSignIn
                this.MFADeliveryMedium = user.challengeParam.CODE_DELIVERY_DELIVERY_MEDIUM
                this.MFADeliveryDestination = user.challengeParam.CODE_DELIVERY_DESTINATION
            }
            else {
                AmplifyEventBus.$emit('authState', user)
            }
        })
        .catch((error) => {
            // alert(error.message)
            this.lastError=error.message
        })             
    },
    async completeMFASubmit() {
        const { code, user, mfaType} = this.completeMFA_form
        await Auth.confirmSignIn(user, code, mfaType)
        .then( (user) => {
            this.$store.dispatch('authstore/setUser', user)
            AmplifyEventBus.$emit('authState', user)
            this.lastError=''
        })
        .catch((error) => {
            this.lastError=error.code +': '+error.message
        })             
    },
  }
}
</script>

<style scoped>
/*
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 400px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
.button {
  height: 45px;
  border: none;
  outline: none;
  background-color: #dddddd;
  margin-top: 8px;
  cursor: pointer;
  font-size: 18px;
}
.button:hover {
  opacity: .7
}*/
</style>

